import authService from "../services/auth";

export default {
  namespaced: true,
  state: {
    auth: null,
    user: null,
  },
  getters: {
    accessToken(state) {
      return state.auth ? state.auth.access_token : null;
    },
    refreshToken(state) {
      return state.auth ? state.auth.refresh_token : null;
    },
    isLoggedIn(state) {
      return !!state.auth;
    },
    isAdmin(state) {
      return (
        state.user.admin && (state.user.admin === 1 || state.user.admin === "1")
      );
    },
    auth(state) {
      return state.auth;
    },
    user(state) {
      return state.user;
    },
  },
  mutations: {
    auth(state, auth) {
      localStorage.setItem("auth", JSON.stringify(auth));
      state.auth = auth;
    },
    user(state, user) {
      state.user = user;
    },
    notifications(state, notifications) {
      state.user.notifications = notifications;
    },
  },
  actions: {
    login(context, credentials) {
      return new Promise((resolve, reject) => {
        authService
          .login(credentials)
          .then((response) => {
            this.commit("user/auth", response);
            this.dispatch("user/userinfo")
              .then(() => {
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    refresh(context) {
      return new Promise((resolve, reject) => {
        authService
          .refresh(context.getters.refreshToken)
          .then((response) => {
            this.commit("user/auth", response);
            this.dispatch("user/userinfo")
              .then(() => {
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            this.commit("user/auth", null);
            this.commit("user/user", null);
            reject(error);
          });
      });
    },
    userinfo() {
      return new Promise((resolve, reject) => {
        authService
          .userinfo()
          .then((response) => {
            this.commit("user/user", response);
            resolve(response);
          })
          .catch((error) => {
            this.dispatch("user/logout");
            reject(error);
          });
      });
    },
    logout() {
      return new Promise((resolve, reject) => {
        authService
          .logout()
          .then((response) => {
            this.commit("user/auth", null);
            this.commit("user/user", null);
            resolve(response);
          })
          .catch((error) => {
            this.commit("user/auth", null);
            this.commit("user/user", null);
            reject(error);
          });
      });
    },
    notifications(context, value) {
      context.commit("notifications", value);
    },
  },
};
